import React, { useState } from "react";
import OtpInput from "react-otp-input";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {
  Avatar,
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import styles from "./ResetOtp.module.scss";
import { useNavigate } from "react-router-dom";
import { rootColors } from "../../utilities/Colors/Colors";

const ResetOtp = () => {
  const [otp, setOtp] = useState(null);
  const naviagte = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setOtp(null);
    setTimeout(() => {
      naviagte("/recoveraccount/setuppassword");
    }, 1000);
  };

  return (
    <Stack
      className={styles.root}
      onSubmit={handleSubmit}
      justifyContent={"center"}
      alignItems={"center"}
      gap={5}
      m={"8rem 0"}
    >
      {/* <Seo
        title={"ResetOtp | Won-Call AI"}
        description={"Seo description"}
        type={"website"}
      /> */}
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar
            sx={{
              m: 1,
              background: rootColors?.primary,
              fontWeight: "500",
              color: "white",
            }}
          >
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Reset Code
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
            gap={"18px"}
          >
            <OtpInput
              inputStyle={{
                border: "2px solid white",
                backgroundColor: "transparent",
                color: "white",
                width: "50px",
                height: "50px",
                borderRadius: "4px",
                outline: "none",
                textAlign: "center",
              }}
              skipDefaultStyles={true}
              value={otp}
              onChange={setOtp}
              inputType="number"
              shouldAutoFocus
              numInputs={4}
              renderSeparator={<span style={{ marginRight: "1rem" }}></span>}
              renderInput={(props) => <input {...props} />}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                backgroundColor: rootColors?.primary,
                color: "white",
                "&:hover": {
                  backgroundColor: rootColors?.primary,
                },
                fontWeight: "500",
              }}
            >
              Submit Code
            </Button>
            <Grid container>
              <Grid item xs={12}>
                <Link href="/contact" variant="body2" color={"#fff"}>
                  Need Help? Contact us
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </Stack>
  );
};

export default ResetOtp;
